const initialState = {
  error_message: "",
  loading: false,
  authenticated: false,
  user: undefined,
  session_token: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "CONECTADO":
      return {
        ...state,
        authenticated: true,
      };
    case "DESCONECTADO":
      return {
        ...initialState,
        error_message: "Session closed",
      };
    case "ERROR":
      return {
        ...state,
        authenticated: false,
        error_message: "Wrong user or password",
      };
    case "AUTH_WHOIAM_SUCCESS":
      return {
        ...state,
        user: action.payload,
      };

    default:
      return state;
  }
};
